// The Chase chip for a receipt: its words and its look, from the match state
// and the linked charge. Shared by the receipt screen and the receipts table.
import { usd } from './money';
import { noBankText } from './cardText';

/** card: the cardText fields (see cardText.js), for the words on a no-bank receipt. */
export function matchTag(receipt, linkedCharge, card = null) {
  const s = receipt?.match?.status ?? null;
  if (s === 'linked') {
    const exact = linkedCharge && linkedCharge.amount === receipt.total;
    if (linkedCharge?.how === 'auto_tip' && linkedCharge.impliedTip !== null) return { cls: 'rc-tag--amber', text: `Matches Chase with ${usd(linkedCharge.impliedTip)} tip · confirm` };
    return { cls: 'rc-tag--ok', text: exact ? 'Matches Chase, to the penny' : 'Matches Chase' };
  }
  if (s === 'no_bank_match_expected') return { cls: 'rc-tag--grey', text: card ? noBankText(card) : 'No bank match expected' };
  if (s === 'candidates') return { cls: 'rc-tag--amber', text: `Several charges fit (${(receipt.match.candidates || []).length})` };
  if (s === 'duplicate_suspected') return { cls: 'rc-tag--amber', text: 'Possible duplicate' };
  if (s === 'no_charge_found') return { cls: 'rc-tag--bad', text: 'No charge found' };
  if (s === 'void') return { cls: 'rc-tag--grey', text: 'Void' };
  return { cls: 'rc-tag--wait', text: 'Waiting for the charge' };
}
